<span class="gw-rv-attributes-answers__textfield-answer">
    <slot />
</span>

<style lang="postcss">
    .gw-rv-attributes-answers {
        &__textfield-answer {
            font-size: 0.875em;
            font-weight: 600;
        }
    }
</style>
